import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { OrderSplit } from "../../../../../../core/ek-e-commerce/ek-models/orderSplit";
import {
  FolderModel,
  FolderStates,
} from "../../../../../../core/ek-e-commerce/ek-models/folder.model";
import { FoldersService } from "../../../../../../core/ek-e-commerce/ek-services/folders.service";
import { OrderSplitService } from "../../../../../../core/ek-e-commerce/ek-services/order-split.service";
import { FormControl } from "@angular/forms";
import {
  LayoutUtilsService,
  MessageType,
} from "../../../../../../core/_base/crud";
import { MatDialog } from "@angular/material/dialog";
import { AddCommentComponent } from "../folder-steps/folder-step-eight/add-comment/add-comment.component";
import { BehaviorSubject, Observable, of } from "rxjs";
import { ShippingAddressFolderModel } from "../../../../../../core/ek-e-commerce/ek-models/shipping-address-folder.model";
import { DocumentService } from "../../../../../../core/services/document.service";
import { ocrInfo } from "../../../../../../core/ek-e-commerce/ek-models/document-ocr-information";
import { FolderVerificationService } from "../../../../../../core/services/folder-verification.service";
import { DocumentModel } from "../../../../../../core/ek-e-commerce/ek-models/document.model";
import { MenuConfigService } from "../../../../../../core/_base/layout";
import { ConfirmDuplicateDialogComponent } from "../folders-pop-up/components/confirm-duplicate-dialog/confirm-duplicate-dialog.component";
import { EtayssirService } from "../../../../../../core/services/etayssir.service";
import { InformationComplimentDialogComponent } from "./information-compliment-dialog/information-compliment-dialog.component";

@Component({
  selector: "kt-folder-process",
  templateUrl: "./folder-process.component.html",
  styleUrls: ["./folder-process.component.scss"],
})
export class FolderProcessComponent implements OnInit, OnDestroy {
  @Input() orderSplit: OrderSplit;
  @Input() folder: FolderModel;
  @Input() isNewOrder = false;

  picExists$: Observable<boolean>;

  folderState: FolderStates;
  remarkStatus = new FormControl();
  idFolder = 0;
  idOrder = 0;
  OrdersTitle: string;
  step: number;
  public folderStateObs$: Observable<FolderStates>;
  orderSplitId: string | undefined;
  shippingAdr: ShippingAddressFolderModel = null;
  currentRole = "";
  ocrInfos: ocrInfo = null;
  bankDocHasCheked = false;
  allOneByOneIsChecked = false;
  documentStates: string[] = [];
  // Initial loading states
  private folderStateLoadObs$ = new BehaviorSubject<{ [key: string]: boolean }>(
    {
      STATE: false,
      CANCEL: false,
      RESERVE: false,
      REJECT: false,
      VALIDATE: false,
    },
  );
  readonly loadingState$ = this.folderStateLoadObs$.asObservable();

  constructor(
    private route: ActivatedRoute,
    public folderService: FoldersService,
    private orderSplitService: OrderSplitService,
    private router: Router,
    private etayssirService: EtayssirService,
    private layoutUtilsService: LayoutUtilsService,
    private dialog: MatDialog,
    private documentService: DocumentService,
    public folderVerificationService: FolderVerificationService,
    private menuConfigService: MenuConfigService,
  ) {
    this.currentRole = JSON.parse(localStorage.getItem("currentUser")).roles;
  }

  ngOnInit(): void {
    this.documentService.allOneByOneIsCheckedSubject.subscribe((data) => {
      this.allOneByOneIsChecked = data;
    });

    this.documentService.isBankDocCheckedSubject.subscribe((data) => {
      this.bankDocHasCheked = data;
    });

    this.documentService.ocrSubject.subscribe((data) => {
      this.ocrInfos = data;
    });

    this.route.paramMap.subscribe((res: ParamMap) => {
      this.OrdersTitle = this.route.snapshot.data["title"];
    });

    this.route.queryParams.subscribe((params: any) => {
      this.step = params["step"] ? Number(params["step"]) : 1;
    });

    // Empty Order - adding new order
    this.route.paramMap.subscribe((params) => {
      this.idFolder = Number(params.get("idFolder"));
      this.idOrder = Number(params.get("idOrder"));
    });

    this.folderVerificationService.documents$.subscribe((docs) => {
      if (docs) {
        this.picExists$ = of(
          !!docs.find((doc) => doc.documentsGender === "PHOTO_IDENTITY"),
        );
      }
    });

    this.folderService.selectedFolderSubject$.subscribe((res) => {
      if (res) {
        this.folder = res;
        if (!this.isNewOrder) {
          this.folderService.folderStateSubj$.next(res.folderState);
        }
        this.folderStateObs$ =
          this.folderService.folderStateSubj$.asObservable();
        this.folderState = res.folderState;
      }
    });

    this.folderService.folderStateSubj$.subscribe(
      (state) => (this.folderState = state),
    );

    // list of documents states which have type different from 'GUARANTEES' & BANK
    this.folderVerificationService.documents$.subscribe({
      next: (documents) => {
        if (documents) {
          this.documentStates = documents
            .filter(
              (document: DocumentModel) =>
                document.documentsType !== "GUARANTEES" &&
                document.documentsType !== "BANK" &&
                document.documentsType !== "INVOICE" &&
                document.documentsGender !== "OTHER",
            )
            .map((item) => item.documentsState);
        }
      },
    });

    this.getShippingAddress();
  }

  setLoading(buttonKey: string, isLoading: boolean) {
    const current = this.folderStateLoadObs$.value;
    this.folderStateLoadObs$.next({
      ...current,
      [buttonKey]: isLoading,
    });
  }

  cancelAllLoadingsSpinners() {
    const resetState = Object.keys(this.folderStateLoadObs$.value).reduce(
      (acc, key) => {
        acc[key] = false;
        return acc;
      },
      {} as { [key: string]: boolean },
    );

    this.folderStateLoadObs$.next(resetState);
  }

  isValidateButtonDisabled() {
    // if documents are not uploaded and accepted , role credit can not validate folder ...
    if (
      this.documentStates.length === 0 ||
      this.documentStates.includes("PENDING") ||
      this.documentStates.includes("REFUSED")
    ) {
      return true;
    }
    return false;
  }

  isButtonHidden(status: string) {
    if (this.folderState) {
      if (this.currentRole === "ROLE_GUEST_ADMIN") {
        return true;
      }
      switch (status) {
        case "CANCEL":
          return (
            this.folderState === "EK_BANK_REFUSED" ||
            this.folderState === "EK_FOLDER_REFUSED" ||
            this.folderState === "EK_BANK_PHYSICAL_FOLDER_ACCEPTED"
          );
        case "RESERVE":
          return !(
            this.folderState === "EK_FOLDER_IN_PROGRESS" ||
            this.folderState === "CENTRAL_RISK_CONSULTATION" ||
            this.folderState === "CLIENT_CENTRAL_RISK_NOTIFICATION" ||
            this.folderState === "EK_BANK_IN_PROGRESS" ||
            this.folderState === "BANK_NOTIFICATION" ||
            this.folderState === "EK_GUARTENTEES_SIGNED_IN_PROGRESS" ||
            this.folderState === "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS" ||
            this.folderState === "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS"
          );
        case "REJECT":
          return !(
            this.folderState === "EK_FOLDER_IN_PROGRESS" ||
            this.folderState === "CENTRAL_RISK_CONSULTATION" ||
            this.folderState === "CLIENT_CENTRAL_RISK_NOTIFICATION" ||
            this.folderState === "EK_BANK_IN_PROGRESS" ||
            this.folderState === "BANK_NOTIFICATION" ||
            this.folderState === "EK_GUARTENTEES_SIGNED_IN_PROGRESS" ||
            this.folderState === "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS" ||
            this.folderState === "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS"
          );
        case "VALIDATE":
          // if document non verified , pos can not validate folder
          if (
            this.currentRole === "ROLE_POS_EK" &&
            this.folderState === "EK_FOLDER_CREATED" &&
            (!this.ocrInfos || !this.allOneByOneIsChecked)
          ) {
            return true;
          }

          if (
            this.currentRole === "ROLE_BANKER_EK" &&
            this.folderState === "EK_BANK_RESERVE"
          ) {
            return true;
          }

          if (
            this.currentRole === "ROLE_CONFORMITY_MANAGER" &&
            this.folderState !== "EK_GUARTENTEES_PENDING_SIGNATURE" &&
            this.folderState !== "EK_GUARTENTEES_SIGNED_IN_PROGRESS" &&
            this.folderState !== "FINANCIAL_FOLDER"
          ) {
            return true;
          }

          if (
            this.currentRole === "ROLE_BACKOFFICE_MANAGER" &&
            this.folderState === "CLIENT_CENTRAL_RISK_NOTIFICATION"
          ) {
            return false;
          }

          if (
            (this.currentRole === "ROLE_ADMIN" ||
              this.currentRole === "ROLE_SUPERADMIN") &&
            (this.folderState === "CLIENT_CENTRAL_RISK_NOTIFICATION" ||
              this.folderState === "BANK_PAYMENT_CONFIRMATION")
          ) {
            return false;
          }

          return !(
            this.folderState === "EK_FOLDER_CREATED" ||
            this.folderState === "EK_FOLDER_IN_PROGRESS" ||
            this.folderState === "CENTRAL_RISK_CONSULTATION" ||
            this.folderState === "CLIENT_CENTRAL_RISK_NOTIFICATION" ||
            this.folderState === "EK_BANK_IN_PROGRESS" ||
            this.folderState === "BANK_NOTIFICATION" ||
            this.folderState === "EK_GUARTENTEES_PENDING_SIGNATURE" ||
            this.folderState === "EK_GUARTENTEES_SIGNED_IN_PROGRESS" ||
            this.folderState === "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS" ||
            this.folderState === "BANK_PAYMENT_CONFIRMATION" ||
            this.folderState === "FINANCIAL_FOLDER" ||
            this.folderState === "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS" ||
            this.folderState === "EK_BANK_PHYSICAL_FOLDER_ACCEPTED" ||
            this.folderState === "EK_FOLDER_RESERVE" ||
            this.folderState === "EK_BANK_RESERVE" ||
            this.folderState === "EK_BANK_PHYSICAL_FOLDER_RESERVE"
          );
      }
    }
  }

  getShippingAddress() {
    this.folderService.shippingSbj$.subscribe((value) => {
      this.shippingAdr = value;
    });
  }

  changeOrderStatus(status: string) {
    console.log("change order or folder status");
    console.log("+++++++" + status);
    this.setLoading(status, true);
    this.setLoading("STATE", true);

    switch (status) {
      // Action: Reject folder
      case "REJECT": {
        const rejectableStates = [
          "EK_FOLDER_IN_PROGRESS", // EK_REFUSE_FOLDER
          "EK_BANK_IN_PROGRESS", //EK_BANK_REFUSE_FOLDER
          "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS", //EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS_TO_EK_BANK_PHYSICAL_FOLDER_REFUSED
          "CENTRAL_RISK_CONSULTATION", //CENTRAL_RISK_CONSULTATION_TO_EK_BANK_REFUSED
          "CLIENT_CENTRAL_RISK_NOTIFICATION", //CLIENT_CENTRAL_RISK_NOTIFICATION_TO_EK_BANK_REFUSED
          "BANK_NOTIFICATION", //BANK_NOTIFICATION_TO_EK_BANK_REFUSED
          "EK_GUARTENTEES_SIGNED_IN_PROGRESS", //EK_GUARTENTEES_SIGNED_IN_PROGRESS_TO_EK_FOLDER_REFUSED
          "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS", //EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS_TO_EK_BANK_REFUSED
        ];

        // Check if current state allows rejection
        if (rejectableStates.includes(this.folder.folderState)) {
          // Open rejection add comment dialog
          this.openDialog(status);
        }

        break;
      }

      // RESERVE folder
      case "RESERVE":
        switch (this.folder.folderState) {
          case "EK_FOLDER_IN_PROGRESS":
            // EK_FOLDER_IN_PROGRESS > EK_FOLDER_RESERVE
            this.openDialog(status, "EK_RETURN_FOLDER");
            break;

          case "EK_BANK_IN_PROGRESS":
            //  EK_BANK_IN_PROGRESS > EK_BANK_RESERVE
            this.openDialog(status, "EK_BANK_RETURN_FOLDER");
            break;

          case "BANK_NOTIFICATION":
            // BANK_NOTIFICATION > EK_BANK_RESERVE
            this.openDialog(status, "BANK_NOTIFICATION_TO_EK_BANK_RESERVE");
            break;

          case "CENTRAL_RISK_CONSULTATION":
            // CENTRAL_RISK_CONSULTATION > EK_BANK_RESERVE
            this.openDialog(
              status,
              "CENTRAL_RISK_CONSULTATION_TO_EK_BANK_RESERVE",
            );
            break;

          case "CLIENT_CENTRAL_RISK_NOTIFICATION":
            // CLIENT_CENTRAL_RISK_NOTIFICATION > EK_BANK_RESERVE
            this.openDialog(
              status,
              "CLIENT_CENTRAL_RISK_NOTIFICATION_TO_EK_BANK_RESERVE",
            );
            break;

          case "EK_GUARTENTEES_SIGNED_IN_PROGRESS":
            // EK_GUARTENTEES_SIGNED_IN_PROGRESS > EK_FOLDER_RESERVE
            this.openDialog(
              status,
              "EK_GUARTENTEES_SIGNED_IN_PROGRESS_TO_EK_FOLDER_RESERVE",
            );
            break;

          case "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS":
            // EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS > EK_BANK_RESERVE
            this.openDialog(
              status,
              "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS_TO_EK_BANK_RESERVE",
            );
            break;

          case "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS":
            // EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS > EK_BANK_PHYSICAL_FOLDER_RESERVE
            this.openDialog(
              status,
              "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS_TO_EK_BANK_PHYSICAL_FOLDER_RESERVE",
            );
            break;
        }
        break;

      // Validate folder
      case "VALIDATE":
        switch (this.folder.folderState) {
          case "EK_FOLDER_CREATED":
            // EK_FOLDER_CREATED > EK_FOLDER_IN_PROGRESS
            this.changeState("EK_IN_PROGRESS_FOLDER");
            break;

          case "EK_FOLDER_IN_PROGRESS":
            // EK_FOLDER_IN_PROGRESS > CENTRAL_RISK_CONSULTATION
            this.changeState(
              "EK_FOLDER_IN_PROGRESS_TO_CENTRAL_RISK_CONSULTATION",
            );
            break;

          case "EK_FOLDER_RESERVE":
            // 1. Extract state names as constants
            const STATES = {
              EK_FOLDER_IN_PROGRESS: "EK_FOLDER_IN_PROGRESS",
              EK_GUARTENTEES_SIGNED_IN_PROGRESS:
                "EK_GUARTENTEES_SIGNED_IN_PROGRESS",
            } as const;

            const TRANSITIONS: Record<string, string> = {
              [STATES.EK_FOLDER_IN_PROGRESS]:
                "EK_FOLDER_RESERVE_TO_EK_FOLDER_IN_PROGRESS",
              [STATES.EK_GUARTENTEES_SIGNED_IN_PROGRESS]:
                "EK_FOLDER_RESERVE_TO_EK_GUARTENTEES_SIGNED_IN_PROGRESS",
            };

            // 2. Cache the property, do one lookup
            const prev = this.folder.folderPreviousState;
            const transition = TRANSITIONS[prev];
            if (transition) {
              this.changeState(transition);
            }
            break;

          case "CENTRAL_RISK_CONSULTATION":
            // CENTRAL_RISK_CONSULTATION > CLIENT_CENTRAL_RISK_NOTIFICATION
            // this.sendFeedback('FINANCEABLE_CLIENT');
            this.changeState(
              "CENTRAL_RISK_CONSULTATION_TO_CLIENT_CENTRAL_RISK_NOTIFICATION",
            );
            break;

          case "CLIENT_CENTRAL_RISK_NOTIFICATION":
            // CLIENT_CENTRAL_RISK_NOTIFICATION > EK_BANK_IN_PROGRESS
            this.changeState(
              "CLIENT_CENTRAL_RISK_NOTIFICATION_TO_EK_BANK_IN_PROGRESS",
            );
            break;

          case "EK_BANK_IN_PROGRESS":
            // EK_BANK_IN_PROGRESS > BANK_NOTIFICATION
            this.changeState("EK_BANK_IN_PROGRESS_TO_BANK_NOTIFICATION");
            break;

          case "BANK_NOTIFICATION":
            // BANK_NOTIFICATION > BANK_NOTIFICATION
            this.changeState(
              "BANK_NOTIFICATION_TO_EK_GUARTENTEES_PENDING_SIGNATURE",
            );
            break;

          case "EK_BANK_RESERVE":
            const folderPreviousState = this.folder.folderPreviousState;
            switch (folderPreviousState) {
              case "CENTRAL_RISK_CONSULTATION":
                // EK_BANK_RESERVE > CENTRAL_RISK_CONSULTATION
                this.changeState(
                  "EK_BANK_RESERVE_TO_CENTRAL_RISK_CONSULTATION",
                );
                break;
              case "BANK_NOTIFICATION":
                // EK_BANK_RESERVE > EK_GUARTENTEES_PENDING_SIGNATURE
                this.changeState("EK_BANK_RESERVE_TO_BANK_NOTIFICATION");
                break;
              case "EK_BANK_IN_PROGRESS":
                // EK_BANK_RESERVE > EK_BANK_IN_PROGRESS
                this.changeState("EK_BANK_RESERVE_TO_EK_BANK_IN_PROGRESS");
                break;
              case "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS":
                this.changeState(
                  "EK_BANK_RESERVE_TO_EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS",
                );
                break;
              case "CLIENT_CENTRAL_RISK_NOTIFICATION":
                this.changeState(
                  "EK_BANK_RESERVE_TO_CLIENT_CENTRAL_RISK_NOTIFICATION",
                );
                break;
              case "CLIENT_CENTRAL_RISK_NOTIFICATION":
                this.changeState(
                  "EK_BANK_RESERVE_TO_CLIENT_CENTRAL_RISK_NOTIFICATION",
                );
                break;
              case "EK_GUARTENTEES_PENDING_SIGNATURE":
                this.changeState(
                  "EK_BANK_RESERVE_TO_EK_GUARTENTEES_PENDING_SIGNATURE",
                );
                break;
            }
            break;

          case "EK_GUARTENTEES_PENDING_SIGNATURE":
            // EK_GUARTENTEES_PENDING_SIGNATURE > EK_GUARTENTEES_SIGNED_IN_PROGRESS
            this.changeState(
              "EK_GUARTENTEES_PENDING_SIGNATURE_TO_EK_GUARTENTEES_SIGNED_IN_PROGRESS",
            );
            break;

          case "EK_GUARTENTEES_SIGNED_IN_PROGRESS":
            // EK_GUARTENTEES_SIGNED_IN_PROGRESS > EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS
            this.changeState(
              "EK_GUARTENTEES_SIGNED_IN_PROGRESS_TO_EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS",
            );
            break;

          case "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS":
            // EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS > BANK_PAYMENT_CONFIRMATION
            this.changeState(
              "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS_TO_BANK_PAYMENT_CONFIRMATION",
            );
            break;

          case "BANK_PAYMENT_CONFIRMATION":
            // BANK_PAYMENT_CONFIRMATION > FINANCIAL_FOLDER
            this.changeState("BANK_PAYMENT_CONFIRMATION_TO_FINANCIAL_FOLDER");
            break;

          case "FINANCIAL_FOLDER":
            // FINANCIAL_FOLDER > EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS
            this.changeState(
              "FINANCIAL_FOLDER_TO_EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS",
            );
            break;

          case "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS":
            // EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS > EK_BANK_PHYSICAL_FOLDER_ACCEPTED
            this.changeState(
              "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS_TO_EK_BANK_PHYSICAL_FOLDER_ACCEPTED",
            );
            break;

          case "EK_BANK_PHYSICAL_FOLDER_RESERVE":
            // EK_BANK_PHYSICAL_FOLDER_RESERVE > EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS
            this.changeState(
              "EK_BANK_PHYSICAL_FOLDER_RESERVE_TO_EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS",
            );
            break;
        }
        break;
    }
  }

  openDialogForInfoComplement() {
    const dialogRefComp = this.dialog.open(
      InformationComplimentDialogComponent,
      {
        width: "460px",
        data: {
          requestNumber: this.folder.requestNumber,
          folderId: this.folder.id,
        },
      },
    );

    dialogRefComp.afterClosed().subscribe((res: boolean) => {
      this.cancelAllLoadingsSpinners();
    });
  }

  changeState(state: string) {
    console.log("aaaaa");
    this.folderService.changeState(this.folder.id, state).subscribe({
      next: (res) => {
        this.updateOrderState(res);

        this.cancelAllLoadingsSpinners();

        // reload aside left folders list
        this.getFoldersStatisticsForMenuConfigs();
      },
      error: (error) => {
        console.log("error", error);

        this.cancelAllLoadingsSpinners();

        const message = this.getChangeStateErrorMessage(error);
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Create,
          5000,
          false,
          false,
        );
      },
    });
  }

  sendFeedback(feedback: string) {
    this.folderService.sendFeedback(this.folder.id, feedback).subscribe({
      next: (res) => {
        this.folderService.folderStateSubj$.next(res as FolderStates);
        this.cancelAllLoadingsSpinners();
        this.refresh();
      },
      error: (error) => {
        if (error.error.code === 401) {
          const message = `vous pouvez pas faire cette opération !`;
          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Create,
            5000,
            false,
            false,
          );
        }

        if (error.status === 403) {
          const message = `vous pouvez pas changer le statut !`;
          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Create,
            5000,
            false,
            false,
          );
        }

        this.cancelAllLoadingsSpinners();
      },
    });
  }

  updateOrderState(folderState: FolderStates) {
    // change order split state
    switch (folderState) {
      case "EK_GUARTENTEES_PENDING_SIGNATURE":
        // prepare order
        this.changeStateOrder("EK_PREPARE_ORDER");
        break;
      case "EK_BANK_REFUSED" ||
        "EK_FOLDER_REFUSED" ||
        "EK_BANK_PHYSICAL_FOLDER_REFUSED":
        // cancel order split
        this.cancelOrderSplit();
        break;
    }

    this.refresh();
  }

  refresh() {
    this.folderService.getFolderById(this.folder.id).subscribe((res) => {
      if (res) {
        this.folderService.folderStateSubj$.next(res.folderState);
        this.folderState = res.folderState;
        this.folderService.selectedFolderSubject$.next(res);
        this.cancelAllLoadingsSpinners();
        this.router.navigateByUrl(
          "ek-ecommerce/folder/edit/" +
            this.idOrder +
            "/" +
            this.idFolder +
            "?step=" +
            this.step,
        );
      }
    });

    // reload aside left folders list
    this.getFoldersStatisticsForMenuConfigs();
  }

  changeStateOrder(orderState) {
    this.orderSplitService
      .changeStateOrderSplit(this.idOrder, orderState)
      .subscribe((res) => {
        if (res) {
          const message = `le statut de la commande a été bien modifié!`;
          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Create,
            5000,
            false,
            false,
          );
        }
      });
  }

  getFoldersStatisticsForMenuConfigs() {
    this.folderService.FoldersStatistics().subscribe({
      next: (res) => {
        this.menuConfigService.statisticsSubject$.next(null as any);
        this.menuConfigService.statisticsSubject$.next(res.countFolderState);
      },
    });

    if (
      this.currentRole === "ROLE_ADMIN" ||
      this.currentRole === "ROLE_SUPERADMIN" ||
      this.currentRole === "ROLE_BANKER_EK"
    ) {
      this.folderService.GlobalFolderStatistics().subscribe({
        next: (res) => {
          this.menuConfigService.GlobalFolderStatisticsSubject$.next(
            null as any,
          );
          this.menuConfigService.GlobalFolderStatisticsSubject$.next(
            res.countFolderState,
          );
        },
      });
    }
  }

  cancelOrderSplit() {
    const date = new Date();

    if (this.remarkStatus.value) {
      const cancelObj = {
        cancellingDate: date.toISOString(),
        cancellingReason: this.remarkStatus.value,
      };

      // return status : EK_CLIENT_ORDER_CANCELED
      this.orderSplitService
        .cancelOrderSplit(this.idOrder, cancelObj)
        .subscribe((res) => {
          if (res) {
            const message = `le statut de la commande a été bien annulée!`;
            this.layoutUtilsService.showActionNotification(
              message,
              MessageType.Create,
              5000,
              false,
              false,
            );
          }
        });
    }
  }

  openDialog(buttonKey: string, changeStatusEvent?: string) {
    this.setLoading(buttonKey, true);
    this.setLoading("STATE", true);

    const title = "Motif d'annulation";

    const dialogRef = this.dialog.open(AddCommentComponent, {
      width: "480PX",
      data: {
        cancelingOrder: true,
        idFolder: this.idFolder,
        idOrder: this.idOrder,
        title,
        folderState: this.folder.folderState,
        changeStatusEvent,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.cancelAllLoadingsSpinners();
      this.refresh();
    });
  }

  cancelFolder(): void {
    this.setLoading("CANCEL", true);
    this.setLoading("STATE", true);

    const title = "Motif d'annulation";

    const dialogRef = this.dialog.open(AddCommentComponent, {
      width: "480PX",
      data: {
        cancelingOrder: false,
        idFolder: this.idFolder,
        idOrder: this.idOrder,
        title,
        folderState: this.folder.folderState,
        changeStatusEvent: null,
        isCancelFolder: true,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.cancelAllLoadingsSpinners();
      this.refresh();
    });
  }

  ngOnDestroy() {
    this.folderService.folderStateSubj$.next(null);
    this.picExists$ = null as any;
  }

  duplicateFolder(): void {
    this.folderService.duplicateFolder(this.folder.id).subscribe(
      (newFolderId) => {
        // Use the newly created folder ID to fetch the corresponding Order Split ID
        this.orderSplitService.getOrderSplitIdByFolderId(newFolderId).subscribe(
          (newOrderSplitId) => {
            // Redirect to the new URL with the parameters
            this.router.navigateByUrl(
              `ek-ecommerce/folder/edit/${newOrderSplitId}/${newFolderId}?step=${this.step}`,
            );
          },
          (error) => {
            // Handle error when fetching the newOrderSplitId
            this.handleError(error, "Failed to fetch Order Split ID");
          },
        );
      },
      (error) => {
        // Handle error when duplicating the folder
        this.handleError(error, "Failed to duplicate folder");
      },
    );
  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(ConfirmDuplicateDialogComponent, {
      width: "400px",
      data: { message: "Voulez-vous vraiment dupliquer ce dossier ?" },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.duplicateFolder();
      }
    });
  }

  hideFromBackOfficeManager(folderStatus: string) {
    return (
      folderStatus !== "EK_FOLDER_IN_PROGRESS" &&
      folderStatus !== "CLIENT_CENTRAL_RISK_NOTIFICATION"
    );
  }

  isValidateDisabled(folderState: string): boolean {
    const isEkRole =
      this.currentRole === "ROLE_CREDIT_ANALYST_EK" ||
      this.currentRole === "ROLE_BACKOFFICE_MANAGER";

    const isCreationOrProgress =
      folderState === "EK_FOLDER_CREATED" ||
      folderState === "EK_FOLDER_IN_PROGRESS";

    const isClientInfoUpdated = this.folderService.clientInfoUpdated$.value;
    const currentFolderState = this.folderService.folderStateSubj$.value;
    const bankFeedback = this.folderService.bankFeedback$.value;

    // condition 1
    const cond1 =
      isEkRole && isCreationOrProgress && this.isValidateButtonDisabled();

    // condition 2
    const cond2 = isEkRole && isClientInfoUpdated !== true;

    // condition 3
    const cond3 =
      currentFolderState === "CENTRAL_RISK_CONSULTATION" &&
      bankFeedback !== "FINANCEABLE_CLIENT";

    // condition 4
    const cond4 =
      currentFolderState === "CENTRAL_RISK_CONSULTATION" && bankFeedback === "";

    return cond1 || cond2 || cond3 || cond4;
  }

  hideButtonsSection(): boolean {
    const state = this.folder?.folderState;

    if (
      this.currentRole === "ROLE_POS_EK" &&
      state === "EK_FOLDER_IN_PROGRESS"
    ) {
      return true;
    }

    // ROLE_CONFORMITY_MANAGER
    if (this.currentRole === "ROLE_CONFORMITY_MANAGER") {
      const allowedStates = [
        "EK_GUARTENTEES_PENDING_SIGNATURE",
        "EK_GUARTENTEES_SIGNED_IN_PROGRESS",
        "FINANCIAL_FOLDER",
      ];
      return !allowedStates.includes(state);
    }

    // ROLE_BANKER_EK
    if (this.currentRole === "ROLE_BANKER_EK") {
      const allowedStates = [
        "CENTRAL_RISK_CONSULTATION",
        "EK_BANK_IN_PROGRESS",
        "BANK_NOTIFICATION",
        "EK_BANK_PHYSICAL_FOLDER_IN_PROGRESS",
        "EK_BANK_PHYSICAL_FOLDER_ACCEPTED",
        "EK_BANK_GUARANTEES_SIGNED_IN_PROGRESS",
      ];
      return !allowedStates.includes(state);
    }

    // ROLE_CREDIT_ANALYST_EK
    if (this.currentRole === "ROLE_CREDIT_ANALYST_EK") {
      const allowedStates = [
        "EK_BANK_RESERVE",
        "EK_FOLDER_IN_PROGRESS",
        "EK_GUARTENTEES_PENDING_SIGNATURE",
        "EK_GUARTENTEES_SIGNED_IN_PROGRESS",
      ];
      return !allowedStates.includes(state);
    }

    // rôles toujours cachés
    const hiddenRoles = [
      "ROLE_GUEST_ADMIN",
      "ROLE_COMMERCIAL",
      "ROLE_COMMERCIAL_MANAGER",
    ];
    if (hiddenRoles.includes(this.currentRole)) {
      return true;
    }

    // FIN PROCESS
    if (state === "EK_BANK_PHYSICAL_FOLDER_ACCEPTED") {
      return true;
    }

    return (
      this.currentRole === "ROLE_BACKOFFICE_MANAGER" &&
      this.hideFromBackOfficeManager(state)
    );
  }

  // Error handling helper function
  private handleError(error: any, defaultMessage: string): void {
    let errorMessage = defaultMessage;

    if (error.error && error.error.message) {
      errorMessage = error.error.message;
    } else if (error.status === 404) {
      errorMessage = "Resource not found";
    } else if (error.status === 401) {
      errorMessage = "Unauthorized access";
    } else if (error.status === 500) {
      errorMessage = "Internal server error";
    }

    alert("Une erreur s'est produite lors de la duplication du dossier.");
  }

 /**
 * handle change state error messages
 */
private getChangeStateErrorMessage(error: any): string {
  const errorBody = error?.error?.body ?? error?.error ?? "";

  if (
    typeof errorBody === "string" &&
    errorBody.startsWith(
      "The generated PDF must have exactly 4 pages. Found:",
    )
  ) {
    return "Le PDF généré doit contenir exactement 4 pages.";
  }

  if (typeof errorBody === "string" && errorBody.includes("Certificat de fabrication")) {
    return "L’URL du certificat de fabrication est invalide.";
  }

  if (
    Array.isArray(errorBody) &&
    errorBody.some((item: any) => item?.field_name === "orderDTO.numberOfMonths")
  ) {
    return "La durée de financement sélectionnée n’est pas valide pour ce montant.";
  }

  if (
    Array.isArray(errorBody) &&
    errorBody.some((item: any) => item?.field_name === "orderDTO.orderProducts[].categoryParent")
  ) {
    return "La catégorie parente sélectionnée n’est pas valide.";
  }

  if (error?.status === 403) {
    return "Vous ne pouvez pas changer le statut !";
  }

  if (error?.error?.code === 401 || error?.status === 401) {
    return "Vous ne pouvez pas effectuer cette opération !";
  }

  return "Une erreur est survenue lors du changement de statut.";
}
}
